module.exports = __webpack_public_path__ + "images/backgrounds/city/medium.20cd2237ca11f77edf5a.jpg";